module.exports = __webpack_public_path__ + "img/flag-pennant.190a04e6.svg";